import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ActionCreator, AnyAction } from 'redux';

const useSyncValueToStore = <A extends AnyAction>(action: ActionCreator<A>, value: unknown) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(action(value));
  }, [value, dispatch, action]);
};

export default useSyncValueToStore;
